import { render } from "./recommendations-carousel.vue?vue&type=template&id=d827f044"
import script from "./recommendations-carousel.vue?vue&type=script&lang=js"
export * from "./recommendations-carousel.vue?vue&type=script&lang=js"

import "./recommendations-carousel.vue?vue&type=style&index=0&id=d827f044&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__